import React, { useState, useEffect } from 'react';
import Joystick from './Joystick';
import MultipleButton from './MultipleButton'; // Import the component
import { SendMessageToServer } from "./SendMessageToServer";
import './App.css';

function ControllerSection({ socket, clientIDRef, playerName, image, inputMsg, setlureBtnLabel }) {
    const [isJoystickActive, setIsJoystickActive] = useState(false);

    const lureText = "Lure", releaseText = "Release";
    const [lastState, setLastState] = useState(lureText); // Use useState
    const [currState, setCurrState] = useState(lureText);

    const ClickToSendToServer = (buttonLabel) => {
        // console.log(`Button ${buttonLabel} was clicked!`);
        SendMessageToServer(socket, clientIDRef, buttonLabel, false);
    };

    const ProfileButtonSet = [
        { id: 'pbtn1', key: '1', label: 'Reveal', color: '#ab1616', pressedColor: '#ba9771', position: { top: 0, left: 0 }, image: image, imgRadius: 170 },
        { id: 'pbtn2', key: '2', label: 'Lure&Exit', color: currState === releaseText ? '#1c8544' : '#c4380a', pressedColor: '#ba9771', position: { top: 10, left: 75 } }
    ];
    const RightButtonSet = [
        { id: 'rbtn1', key: '1', label: 'Cancel', color: '#1c8544', pressedColor: '#ba9771', position: { top: -20, left: '18%' } },
        { id: 'rbtn2', key: '2', label: 'Dash', color: '#ab1616', pressedColor: '#ba9771', position: { top: '10%', left: '50%' }, radiusSize: 110 },
        { id: 'rbtn3', key: '3', label: 'Cover', color: '#ccaf0a', pressedColor: '#ba9771', position: { top: '30%', left: 0 } },
        { id: 'rbtn4', key: '4', label: 'Join', color: '#92ab16', pressedColor: '#ba9771', position: { top: '64%', left: '29%' } },

        //{ id: 'rbtn5', key: '5', label: 'Shoot', color: '#4c00ffff', pressedColor: '#ba9771', position: { top: '100%', left: '50%' }, radiusSize: 110},
    ];
    const EventButtonSet = [
        { id: 'ebtn1', key: '1', label: 'Date', color: '#e67219', pressedColor: '#ba9771', position: { top: 0, left: 0 } },
        { id: 'ebtn2', key: '2', label: 'Party', color: '#ccaf0a', pressedColor: '#ba9771', position: { top: 0, left: 85 } },
    ];

    // color: '#1c8544'
    const handleJoystickMove = (position) => {
        setIsJoystickActive(true);
        //console.log('Joystick position:', position); // Values between -1 and 1
        const joystickMessage = `${position.x.toFixed(2) * -1},${position.y.toFixed(2) * -1}`;
        SendMessageToServer(socket, clientIDRef, joystickMessage, false);
    };

    const handleJoystickStop = () => {
        if (isJoystickActive) {
            //console.log('Joystick centered');
            SendMessageToServer(socket, clientIDRef, "Joystick-Stopped", false);
            setIsJoystickActive(false);
        }
    };

    const controlBtnNames = ["Joystick-Stopped", "Date", "Party", "Cancel", "Dash", "Cover", "Join"];
    //const controlBtnNames = ["Joystick-Stopped", "Date", "Party", "Cancel", "Dash", "Cover", "Join", "Shoot"];
    const ControllerActivationCheck = (inputMessage) => {
        if (isJoystickActive)
            return true;

        if (isCoordination(inputMessage))
            return true;

        if (controlBtnNames.includes(inputMessage))
            return true;
        return false;
    };
    const isCoordination = (inputMessage) => {
        if (inputMessage === "")
            return false;
        if (inputMessage === null)
            return false;

        const suspectedCoordDatas = inputMessage.split(",");
        if (suspectedCoordDatas.length !== 2)
            return false;

        if (suspectedCoordDatas[0] === "" || suspectedCoordDatas[1] === "")
            return false;

        return !isNaN(suspectedCoordDatas[0]) && !isNaN(suspectedCoordDatas[1]);
    };
    const isControllerActivated = ControllerActivationCheck(inputMsg);
    const isControllerSectionDisable = currState !== releaseText;

    useEffect(() => {
        const profileBtnNames = ["Lure&Exit", lureText, "Reveal", releaseText];

        if (!inputMsg) {
            setCurrState(lureText);
            return;
        }
        setlureBtnLabel(currState.toString());
        const newMsgText = inputMsg.trim();
        if (newMsgText === "" || newMsgText === "Lure&Exit" || newMsgText === lureText) {
            setLastState(lureText);
            setCurrState(lureText);
        }
        else if (newMsgText === "Reveal") {
            setCurrState(lastState);
        }
        else if (!isControllerActivated && !profileBtnNames.includes(newMsgText)) {
            setLastState(lureText);
            setCurrState(lureText);
        }
        else if (isControllerActivated || newMsgText === releaseText) {
            setLastState(releaseText);
            setCurrState(releaseText);
        }

    }, [inputMsg, lastState, currState, isControllerActivated, lureText, releaseText, setlureBtnLabel]);

    let GamepadSetUIs =
        <div style={{ position: 'relative', top: 140 }}>
            <div style={{ position: 'absolute' }}>
                <Joystick
                    onMove={handleJoystickMove}
                    onStop={handleJoystickStop}
                    isDisabled={isControllerSectionDisable}//{false}//
                />
                <div style={{ position: 'absolute', top: 160, left: -5 }}>
                    <MultipleButton buttonData={EventButtonSet} onClick={ClickToSendToServer} isDisabled={isControllerSectionDisable}>
                        {{ ebtn1: "", ebtn2: "" }}
                    </MultipleButton>
                </div>
            </div>
            <div style={{ position: 'absolute', right: 25, width: '180px', height: '180px' }}>
                <MultipleButton buttonData={RightButtonSet} onClick={ClickToSendToServer} isDisabled={isControllerSectionDisable}>
                    {{ rbtn1: "", rbtn2: "", rbtn3: "", rbtn4: "" }}
                </MultipleButton>
            </div>
        </div>

    return (
        <div>
            <div className="alignedUpperCenter" style={{ position: 'relative' }}>
                <div style={{ position: 'absolute' }}>
                    <MultipleButton buttonData={ProfileButtonSet} onClick={ClickToSendToServer}>
                        {{ pbtn1: "", pbtn2: `${currState}` }}
                    </MultipleButton>
                </div>
                <h1 style={{ position: 'absolute', top: 60 }}>{playerName.split('').join('.')}</h1>
            </div>
            {GamepadSetUIs}
        </div>);
};
export default ControllerSection;